import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'vh-footer',
  standalone: true,
  imports: [RouterLink],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <footer class="vh-footer">
      <div class="vh-footer__inner">
        <div class="vh-footer__brand">
          <a routerLink="/" class="vh-footer__logo"> <span>Vendor</span><strong>Hub</strong> </a>
          <p>
            Public discovery for trusted event vendors, agencies, professionals, and venues across
            India.
          </p>
        </div>

        <div class="vh-footer__col">
          <h4>Discover</h4>
          <a routerLink="/vendors">Browse Vendors</a>
          <a routerLink="/vendors" [queryParams]="{ category: 'venues' }">Venues</a>
          <a routerLink="/vendors" [queryParams]="{ category: 'event-planners' }">Planners</a>
        </div>

        <div class="vh-footer__col">
          <h4>Customers</h4>
          <a routerLink="/vendors" [queryParams]="{ intent: 'requirement' }">Post Requirement</a>
          <a routerLink="/vendors" [queryParams]="{ city: 'ahmedabad' }">Ahmedabad Vendors</a>
          <a routerLink="/vendors" [queryParams]="{ city: 'mumbai' }">Mumbai Vendors</a>
        </div>

        <div class="vh-footer__col">
          <h4>Providers</h4>
          <a routerLink="/vendors" [queryParams]="{ intent: 'join-vendor' }">Join as Vendor</a>
          <a routerLink="/vendors" [queryParams]="{ badge: 'premium' }">Premium Visibility</a>
          <a routerLink="/vendors" [queryParams]="{ badge: 'verified' }">Verified Profiles</a>
        </div>
      </div>

      <div class="vh-footer__bottom">Copyright 2026 VendorHub. Discovery foundation preview.</div>
    </footer>
  `,
  styleUrl: './footer.component.scss',
})
export class FooterComponent {}
